// import { Html5QrcodeScanner } from "html5-qrcode";
import { Html5Qrcode } from "html5-qrcode";

import { useState, useEffect } from "react"; // import useRef
import PropTypes from "prop-types";
import { Grid, Icon, Snackbar, Alert, Box, Typography, Button, IconButton } from "@mui/material";

function BarcodeReaderField({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [isScanning, setIsScanning] = useState(false);
  const [scannedText, setScannedText] = useState(null);
  const [scannerObj, setsCannerObj] = useState(null);

  const config = { fps: 10, qrbox: { width: 250, height: 250 } };

  function onScanSuccess(decodedText, decodedResult) {
    // handle the scanned code as you like, for example:
    // console.log(`Code matched = ${decodedText}`, decodedResult);
    setScannedText(decodedText);
    closeScanning();
  }

  function openScanner(camera) {
    scannerObj.start(camera, config, onScanSuccess);
    setIsScanning(true);
  }

  function closeScanning() {
    if (scannerObj === null) {
      console.log("Scanner object null");
      return;
    }

    try {
      scannerObj.stop();
      setIsScanning(false);
    } catch {}

    // scannerObj
    //   .stop()
    //   .then((ignore) => {
    //     setIsScanning(false);
    //   })
    //   .catch((err) => {
    //     // Stop failed, handle it.
    //     console.warn(`Code scan error = ${err}`);
    //     setErrorMsg(err);
    //     showFieldError(true);
    //   });
  }

  function initScanning() {
    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices && devices.length) {
          var cameraId = devices[0].id;
          let camera = { deviceId: { exact: cameraId } };
          if (devices.length > 1) {
            camera = { facingMode: "environment" };
          }
          openScanner(camera);
        }
      })
      .catch((err) => {
        // handle err
        console.warn(`Code scan error = ${err}`);
        setErrorMsg(`Code scan error = ${err}`);
        showFieldError(true);
      });
  }

  useEffect(() => {
    setsCannerObj(new Html5Qrcode(`${fieldRef}_scanner`));
  }, []);

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Box sx={{ minWidth: 120, width: "100%" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} md={6} lg={6}>
            <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </Typography>
          </Grid>
          <Grid mt={-1} item xs={6} md={6} lg={6}>
            <Box align="right">
              {!isScanning ? (
                <IconButton
                  color="primary"
                  variant="contained"
                  iconOnly
                  size="small"
                  onClick={() => {
                    initScanning();
                  }}
                  options={options}
                >
                  <Icon>barcode_reader</Icon>
                </IconButton>
              ) : (
                <IconButton
                  color="error"
                  variant="contained"
                  iconOnly
                  size="small"
                  onClick={() => {
                    closeScanning();
                  }}
                  options={options}
                >
                  <Icon>close</Icon>
                </IconButton>
              )}
            </Box>
          </Grid>
        </Grid>
        <Box>
          <div id={`${fieldRef}_scanner`}></div>
        </Box>
        <Box mt={isScanning ? 3 : 0}>
          {scannedText ? (
            <Box>
              <Typography variant="h6" fontSize={14}>
                <b>Scan Result:</b>
                <br />
                {scannedText}
              </Typography>
              <Button
                iconOnly
                size="small"
                onClick={() => {
                  setScannedText(null);
                }}
              >
                [clear]
              </Button>
            </Box>
          ) : (
            <Typography variant="h6" fontSize={14}>
              <small>Scan a bar code</small>
            </Typography>
          )}
        </Box>
      </Box>
      <input id={`dff_${fieldRef}`} type="hidden" name={fieldRef} value={scannedText} />
    </Box>
  );
}

// Typechecking props of the Transaction
BarcodeReaderField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

BarcodeReaderField.defaultProps = {
  options: null,
};

export default BarcodeReaderField;
